import { useSyncExternalStore } from 'react'

type EnvKeys = {
  chatApiKey: string
  videoApiKey: string
  firebasePushProvider: string
  APNsPushProvider: string
}

const environments = {
  production: {
    APNsPushProvider: 'APNs',
    chatApiKey: '9xknd8he8rka',
    videoApiKey: '9xknd8he8rka',
    firebasePushProvider: 'firebase-prod'
  },
  development: {
    APNsPushProvider: 'APNs',
    chatApiKey: "x3jwmavdjc4j",
    videoApiKey: 'x3jwmavdjc4j',
    firebasePushProvider: 'firebase-dev'
  }
} satisfies Record<string, EnvKeys>

type EnvName = keyof typeof environments
 
type Persistor = {
    getEnv: () => EnvName
 

}


type Params = [
  persistor?: Persistor,  defaultEnv?: EnvName
]

type EnvChangeCallback = (env:EnvName) => void

export class ConfigPackage {
  currentEnv: EnvName
  defaultEnv: EnvName
  persistor: Persistor
  handleReload: () => void
  listeners: Set<EnvChangeCallback>

  static instance: ConfigPackage

  constructor(...params: Params){
    this.configure(...params)
    this.listeners = new Set()
    this.onEnvChanged = this.onEnvChanged.bind(this)
    this.use = this.use.bind(this)
    ConfigPackage.instance = this
  }

  configure(...params: Params){
    const [ persistor,  defaultEnv] = params

    this.currentEnv = persistor?.getEnv?.()  ?? defaultEnv
    this.persistor = persistor
    this.defaultEnv = defaultEnv
  }

  setEnvironment(env: EnvName){
    this.currentEnv = env
    this.listeners.forEach(l => {
      l(this.currentEnv)
    })
  }

  onEnvChanged(cb: EnvChangeCallback ){
    this.listeners.add(cb)

    return () => {
      this.listeners.delete(cb)
    }
  }



  get values() {
    return new Proxy({} as EnvKeys, {
      get: (_,p, receiver) => {
        return Reflect.get(environments[this.currentEnv], p, receiver)
      }
    })
  }

  use(){
    const currentEnv = useSyncExternalStore((cb) => this.onEnvChanged(cb), () => this.currentEnv, () => this.currentEnv)

    return {
      values: this.values,
      
      currentEnv
    }
  }

 
}

export const getConfig = (...args: Partial<ConstructorParameters<typeof ConfigPackage>>) => {
  if(ConfigPackage.instance){
     
    return ConfigPackage.instance
  }

  return new ConfigPackage(...args)
} 

